






























  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import { MessagingModule } from '@/store/modules/messaging';
import { AppModule } from '@/store/modules/app';
import ReassignConversationRequest from '@/models/Conversations/AssignConversationRequest';
import CreateConversationParticipantRequest from '@/models/Conversations/CreateConversationParticipantRequest';
import EntityType from '@/models/Shared/EntityType';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';

@Component({
    name: 'CreateConversationParticipant'
})
export default class extends GiganautVueDialog {

    @Prop({required: true})
    entityType: EntityType;

    @Prop({required: true})
    agencyUsers: AgencyUserDto[];

    get agencyUsersFiltered() {
      if (this.entityType === EntityType.Worker) {
        if (WorkerDetailsModule.workerConversationsVM.selectedConversation && WorkerDetailsModule.workerConversationsVM.selectedConversation.participantFirebaseUserIds) {
          return this.agencyUsers.filter(function(agencyUser){
            if (WorkerDetailsModule.workerConversationsVM.selectedConversation.participantFirebaseUserIds.includes(agencyUser.userId)) {
              return false;
            } else {
            return true;
            }
          });
        }
        return this.agencyUsers;
      } else {
         if (MessagingModule.selectedConversation && MessagingModule.selectedConversation.participantFirebaseUserIds) {
          return this.agencyUsers.filter(function(agencyUser){
            if (MessagingModule.selectedConversation.participantFirebaseUserIds.includes(agencyUser.userId)) {
              return false;
            } else {
            return true;
            }
          });
        }
        return this.agencyUsers;
      }
    }

    async createConversationParticipant(agencyUser: AgencyUserDto) {
        const request = new CreateConversationParticipantRequest();
        request.entityId = agencyUser.id;
        request.entityType = this.EntityType.AgencyUser
        if (this.entityType === EntityType.Worker) {
          await WorkerDetailsModule.createConversationParticipant(request);
        } else {
          await MessagingModule.createConversationParticipant(request);
        }
        
    }

    getUserAvatarUrl(user: AgencyUserDto) {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + user.id + "/resized-100/" + user.avatar;
    }
}
